import { render, staticRenderFns } from "./InventoryHandOver.vue?vue&type=template&id=50071e82"
import script from "./InventoryHandOver.vue?vue&type=script&lang=js"
export * from "./InventoryHandOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports